import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../styles/components/BackgroundAnimation.css';

gsap.registerPlugin(ScrollTrigger);

const BackgroundAnimation = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const colors = ['#a29bfe', '#81ecec', '#74b9ff', '#ff7675'];
    const isMobile = window.innerWidth <= 768;

    // Create MORE blobs on mobile for better coverage
    const blobCount = isMobile ? 8 : 5;

    for (let i = 0; i < blobCount; i++) {
      const blob = document.createElement('div');
      blob.classList.add('bg-blob');
      
      // Bigger blobs on mobile
      const size = isMobile 
        ? Math.random() * 300 + 250 // Mobile: 250-550px
        : Math.random() * 400 + 300; // Desktop: 300-700px
      
      blob.style.width = `${size}px`;
      blob.style.height = `${size}px`;
      
      // Ensure each color is used at least once
      const colorIndex = i < colors.length ? i : Math.floor(Math.random() * colors.length);
      blob.style.background = colors[colorIndex];
      
      // Better distribution on mobile
      if (isMobile) {
        // Blobs pushed down on mobile to avoid overlapping the hero headline/Impact text
        // Hero section on mobile occupies roughly the top 55–60% of the viewport
        const positions = [
          { left: '10%', top: '60%' },
          { left: '80%', top: '65%' },
          { left: '50%', top: '75%' },
          { left: '20%', top: '80%' },
          { left: '70%', top: '85%' },
          { left: '40%', top: '90%' },
          { left: '85%', top: '70%' },
          { left: '15%', top: '95%' }
        ];
        
        if (positions[i]) {
          blob.style.left = positions[i].left;
          blob.style.top = positions[i].top;
        }
      } else {
        // Random on desktop
        blob.style.left = `${Math.random() * 100}%`;
        blob.style.top = `${Math.random() * 100}%`;
      }
      
      blob.style.animationDelay = `${Math.random() * 5}s`;
      canvas.appendChild(blob);
    }

    // Scroll animation
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: 'body',
        start: 'top top',
        end: 'bottom bottom',
        scrub: 1,
      },
    });

    // Less movement on mobile
    const moveRange = isMobile ? 50 : 150;

    tl.to('.bg-blob', {
      scale: 1.5,
      x: `random(-${moveRange}, ${moveRange})`,
      y: `random(-${moveRange}, ${moveRange})`,
      rotation: 'random(-180, 180)',
      duration: 40,
      ease: 'none',
    }, 0);

    return () => {
      tl.kill();
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return <div ref={canvasRef} className="bg-scroll-canvas"></div>;
};

export default BackgroundAnimation;